import { FETCH_TICKET_INFO } from '../actions/TicketAction';

export default function (state = {}, action) {
  switch (action.type) {
    case FETCH_TICKET_INFO:
      return {
        ...action.payload
      }  
    default:
      return {
        ...state
      }
  }
};



// WEBPACK FOOTER //
// ./src/reducers/TicketReducer.js